import { useEffect } from "react";

const SSOLogin = () => {
    useEffect(() => {
        const search = new URLSearchParams(window.location.search);

        const access = search.get("access");
        const refresh = search.get("refresh");

        const page = search.get("page") || "Tutorial";
        const params = search.get("params") || "";
        const login = search.get("login") || "";

        // ============================================================
        // STORE TOKENS
        // ============================================================
        if (access) {
            localStorage.setItem("access_token", access);
        }

        if (refresh) {
            localStorage.setItem("refresh_token", refresh);
        }

        // ============================================================
        // PARSE PARAMS
        // ============================================================
        const ssoParams = new URLSearchParams(params);

        const schoolCode = ssoParams.get("SchoolCode") || "";
        const familyCode = login
        console.log("SSO Params:", ssoParams);

        // Store them for SelectUser / Question
        if (schoolCode) {
            sessionStorage.setItem("SchoolCode", schoolCode);
        }

        if (familyCode) {
            sessionStorage.setItem("FamilyCode", familyCode);
        }

        sessionStorage.setItem("isSSO", "true");

        console.log("SSO Page:", page);
        console.log("SSO Params:", params);
        console.log("SchoolCode:", schoolCode);
        console.log("FamilyCode:", familyCode);

        // ============================================================
        // NEW MSR / SELECT USER
        // ============================================================
        if (page === "Login/SelectUser") {
            window.location.replace(
                `/Login/SelectUser?${params}`
            );
            return;
        }

        // ============================================================
        // EXISTING STUDENT PAGES
        // ============================================================
        window.location.replace(
            `/STUDENT/TutorialsCopy/${page}?${params}`
        );
    }, []);

    return <div />;
};

export default SSOLogin;